//basic
import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';



import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import '../../../screens/ExpaleTable/ExampleTable.scss'
//style


//api
// import { api } from '../../functions/api';

//custom components
// import CustomTable3 from '../../components/complex/CustomTable3/CustomTable3';
// import Search from '../../../components/basic/search';
// import CustomButton from '../../../components/basic/CustomButton';



//material-ui
import { CircularProgress, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { mdiDotsVertical, mdiArrowDown,mdiCloudUpload, mdiCloudDownload, mdiCart,mdiPencil } from '@mdi/js'

//other libraries
import queryString from 'query-string';
import Icon from '@mdi/react';
import { mdiPlus } from '@mdi/js';

@inject('internal')
@inject('translate')
@observer
export default class TableHeadRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPage: true,
            addEditDialog: false,
            order: this.props.sortByBy,
            orderBy: this.props.sortByDir
            
        }
    }
componentDidMount() {

}
createSortHandler = (orderBy) => {
    let currentOrder = this.state.order;
    this.setState({orderBy: orderBy});
    if(currentOrder === 'asc') {
        this.setState({order: "desc"}, () => {
            this.props.handleSort(this.state.order, this.state.orderBy);
        })
    }
    else {
        this.setState({order: "asc"}, () => {
            this.props.handleSort(this.state.order, this.state.orderBy);
        })
    }
}

myFunction = (inputText) => {
        this.props.parentFunction(inputText)
  }
  
    render () {

        // title = {}

        return (
                <TableRow>
                    {/* {this.props.HeadValue.map((item,index) => (
                        <TableCell key={index}>
                            {item.title}
                        </TableCell> ))}*/}
                    {this.props.HeadValue.map((item,index) => (
                        <TableCell
                        // onClick={()=>this.myFunction(item.title)} key={index}
                        onClick={()=>this.createSortHandler(item.sortBy?item.sortBy: item.title)}
                        >{item.title}
                             {this.state.order === item.title || this.state.orderBy === item.sortBy ?
                                <Icon path={mdiArrowDown} size={1} className={this.state.order === 'desc' ? ' desc' : 'asc'} />
                                  : null
                            }
                        </TableCell>))}
                </TableRow>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/basic/TableRow/TableHeadRow.jsx